import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Layout, Button, Label } from "tigo-components";
import { HN_TEXTS, imageURLs, appColors, pageURL_HN } from "../../../constants";
import { tigoLogin } from "../../../helpers";
import { appConfig } from "../../../config/appConfig";
import {
  TextContainer,
  ButtonContainer,
  GradientWrapper,
  TitleWrapper
} from "./styled";
import { getCookie, getRedirectValues } from "../../../utils/utils";
import {
  HOMEACTIVATOR_PORTAL_LOADED,
  ACTIVATION
} from '../../../constants/segmentEvents';
import { track } from '../../../utils/segmenTracker';

const Landing = ({ history }) => {
  const apiStatus = useSelector(state => state.apiStatus.data);
  const dispatch = useDispatch();
 
  useEffect(() => {
    dispatch.auth.checkMaintanence({ onMaintanence: (url) => history.push(url)});
    const authCookie = getCookie();
    const authCookieValue = authCookie ? authCookie[2] : null;
    if (!authCookieValue) {
      const { code, serverState, error, localState } = getRedirectValues();
      if (!error) {
        if (code && serverState && localState && serverState === localState) {
          localStorage.removeItem("TIGOPOASTATE");
          dispatch.auth.authenticate({
            code,
            navigateTo
          });
        }
      }
    }
    else {
      history.push(pageURL_HN.home)
    }
  }, [])

  const navigateTo = () => {
    history.push(pageURL_HN.home);
  }

  const handleContinue = () => {
    const { netCodeURL, redirectURL, clientId, codeVerifier } = appConfig;
    track(HOMEACTIVATOR_PORTAL_LOADED, { journey: ACTIVATION });
    tigoLogin(netCodeURL, redirectURL, codeVerifier, clientId);
  };

  return (
    <Layout fullWidth={true} loading={apiStatus.isProcessing}>
      <GradientWrapper color={appColors.blueGradient}>
        <img src={imageURLs.logo} alt="" />
        <TitleWrapper>
          <Label
            text={HN_TEXTS.HOME_TITLE}
            fontColor={appColors.palette.matterHorn}
          />
        </TitleWrapper>
        <TextContainer>
          <Label
            text={HN_TEXTS.HOME_DESCRIPTION}
            fontColor={appColors.palette.matterHorn}
          />
        </TextContainer>
        <ButtonContainer>
          <Button
            variant="rounded"
            onClick={handleContinue}
            text={HN_TEXTS.HOME_BUTTON}
          />
        </ButtonContainer>
      </GradientWrapper>
    </Layout>
  );
}

Landing.propTypes = {
  history: PropTypes.object.isRequired,
}

export default Landing;
